import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Switch } from "./ui/switch";
import { toast } from "sonner";
import { card, err } from "./HubShell";
import { Zap } from "lucide-react";

export const ClipAutoPost = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/tvnet/creator/autopost").then((r) => setD(r.data)).catch(() => {}); }, []);
  const toggle = async (v) => { const prev = d; setD({ ...d, enabled: v }); try { await api.post("/tvnet/creator/autopost", { enabled: v }); toast.success(v ? "Highlight clips will auto-post to your connected channels" : "Auto-post off"); } catch (e) { setD(prev); toast.error(err(e)); } };
  if (!d) return null;
  const conn = Object.entries(d.channels).filter(([, c]) => c.connected).map(([, c]) => c.name);
  return (
    <section className={`${card} p-5 flex flex-wrap items-center gap-4`} data-testid="clip-autopost">
      <div className="flex items-center gap-2"><Zap className="w-4 h-4 text-amber-300" /><span className="font-semibold text-sm">Auto-post highlight clips</span></div>
      <Switch checked={d.enabled} onCheckedChange={toggle} data-testid="clip-autopost-switch" />
      <span className="text-xs text-slate-400" data-testid="clip-autopost-status">{conn.length ? `Posts to ${conn.join(", ")} the moment a highlight clip is cut` : <>No channels connected yet — <Link to="/distribution" className="text-cyan-300 hover:underline">connect Facebook or YouTube</Link>; clips still land in the Distribution Hub as drafts</>}</span>
    </section>
  );
};
